export const cancelButtonStyles = theme => ({
  color: theme.palette.secondary.medium,
  margin: theme.spacing('auto', -1.5, 'auto', 'auto'),
  padding: 0,
});

export const filterDrawerStyles = {
  borderRadius: '4px 0 0 4px',
  width: 250,
};

export const topBarStyles = theme => ({
  '& > h5': {
    fontSize: 20,
    marginTop: 2,
  },
  borderBottom: `0.1em solid ${theme.palette.secondary.light}`,
  height: 48,
  padding: theme.spacing(0.5, 3, 0, 2),
  [theme.breakpoints.down('md')]: {
    height: 56,
  },
});
